import { RiUserFill } from '@remixicon/react';
import { IconButton, Menu, MenuItem, SvgIcon } from '@mui/material';
import { Link, useNavigate } from 'react-router';
import { useLanguage } from '../../contexts/language';
import { useCallback, useState } from 'react';

const AccountMenu = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  // The "/logout" route will handle the proper logging out process
  const handleLogout = () => {
    void navigate('/logout');
  };

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isMenuOpen = Boolean(anchorEl);
  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <span>
      <IconButton
        className="p-2 hover:bg-teal-700"
        onClick={event => setAnchorEl(event.currentTarget)}
      >
        <SvgIcon
          component={RiUserFill}
          className="w-[24px] h-[24px] fill-white"
        />
      </IconButton>
      <Menu anchorEl={anchorEl} open={isMenuOpen} onClose={handleClose}>
        <MenuItem onClick={handleClose}>
          <Link to="/admin/account/profile">{t('content.my-profile')}</Link>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            handleLogout();
          }}
        >
          {t('content.logout')}
        </MenuItem>
      </Menu>
    </span>
  );
};

export default AccountMenu;

export const MobileAccountMenu = ({ className }: { className?: string }) => {
  const { t } = useLanguage();

  // The "/logout" route will handle the proper logging out process

  return (
    <div className={className}>
      <div className="inline-flex gap-2 items-center">
        <Link to="/admin/account/profile">{t('content.my-profile')}</Link>
        <div className="border-l border-iots-brand-inverted h-[16px]" />
        <Link to="/logout">{t('content.logout')}</Link>
      </div>
    </div>
  );
};
